<!--
 * @Description: 
 * @Author: xgx
 * @Date: 2022-09-30 15:25:16
 * @LastEditors: xgx
 * @LastEditTime: 2023-08-22 15:15:28
-->
<template>

  <div class="wrapper">
    <div class="top">
      <div class="back" @click="toBack">
        <a-icon type="arrow-left"/>
      </div>
      创作稿件
      <!--      <Toolbar-->
      <!--        style="padding: 5px 0px"-->
      <!--        :editor="editor"-->
      <!--        :defaultConfig="toolbarConfig"-->
      <!--        :mode="mode"-->
      <!--      />-->
    </div>

    <div class="content-box">
      <a-spin :spinning="loadingBox" tip="数据处理中请稍等">
        <div class="content" :style="{ height: height }">
          <div class="left">
            <div v-if="codeData.indexOf('266') != -1" class="btn-item" @click="openImport(1)">
              <span class="icon-edit-word"></span>
              word导入
            </div>
            <div v-if="codeData.indexOf('267') != -1" class="btn-item" @click="openImport(2)">
              <span class="icon-edit-excel"></span>
              Excel导入
            </div>
            <div v-if="codeData.indexOf('268') != -1" class="btn-item" @click="openImport(3)">
              <span class="icon-edit-pdf"></span>
              PDF导入
            </div>
            <div v-if="codeData.indexOf('269') != -1" class="btn-item" @click="openImport(4)">
              <span class="icon-edit-ppt"></span>
              PPT导入
            </div>
            <div v-if="codeData.indexOf('270') != -1" @click="linkImport" class="btn-item">
              <span class="icon-edit-url"></span>
              链接导入
            </div>
            <div v-if="codeData.indexOf('271') != -1" class="btn-item" @click="openMisse">
              <span class="icon-edit-wrong"></span>
              错敏检测
            </div>
            <div v-if="codeData.indexOf('272') != -1" class="btn-item" @click="openDarkLink">
              <span class="icon-edit-unlink"></span>
              暗链检测
            </div>
            <div v-if="codeData.indexOf('441') != -1" class="btn-item" @click="openTempModal">
              <span class="ri-layout-masonry-line"></span>
              选择模板
            </div>
          </div>
          <div class="middle">
            <div id="zaiYao" class="middle-box">
              <div class="t-title">
                <div class="title" id="article">
                  <el-input
                      v-model="title"
                      placeholder="请输入文章标题"
                  ></el-input>
                </div>
                <div class="info">
                  <div class="block">
                    &emsp;发布时间：
                    <el-date-picker
                        v-model="createTime"
                        type="datetime"
                        placeholder="年/月/日 --:--"
                        :pickerOptions="{
                          disabledDate(time) {
                            return time.getTime() > Date.now();
                          }
                        }">
                    </el-date-picker>
                  </div>
                  <el-form>
                    <el-form-item style="margin-bottom: 0" prop="source" label="来源：">
                      <div class="lai-yuan" style="display: flex; align-items: center">
                      <el-input
                          v-model="source"
                          placeholder="请填写文章来源"
                          style="width: 300px"
                      ></el-input>
                      </div>
                    </el-form-item>
                  </el-form>
                </div>
                <div class="abstract">
                  <el-input
                      v-model="abstractText"
                      placeholder="摘要(选填)"
                  ></el-input>
                </div>
              </div>
              <uEditorWrap v-model="htmlContent"
                           @ready="ueditorReady"
                           editor-id="editor"
                           :config="uEditorConfig"
                           :editorDependencies="['ueditor.config.js','ueditor.all.js']"
                           class="editor-box"/>
<!--              <Editor-->
<!--                  style="height: 500px; overflow-y: hidden; padding: 10px 62px"-->
<!--                  v-model="htmlContent"-->
<!--                  :defaultConfig="editorConfig"-->
<!--                  :defaultContent="jsonContent"-->
<!--                  :mode="mode"-->
<!--                  @onCreated="onCreated"-->
<!--                  @customPaste="customPaste"-->
<!--              />-->
              <div class="setup" id="setup">
                <div style="border-bottom: 1px solid #eeebeb">
                  <div class="set-title">
                    <div id="faWenSet" class="line"></div>
                    发文设置
                    <div class="line"></div>
                  </div>
                  <div class="form-box">
                    <el-form ref="form" label-width="100px">
                      <el-form-item label="发布至栏目">
                        <el-button @click="openChooseColumn"
                        >+添加至栏目
                        </el-button
                        >
                        <div style="font-size: 12px; color: #909399">
                          添加栏目后请在右侧补齐栏目字段
                        </div>
                        <div>
                          <div
                              v-for="(item, index) in columnData"
                              class="one"
                              :key="index"
                          >
                            <div class="name"><span :title="item.columnName">{{ item.columnName }}</span></div>
                            &emsp;
                            <span
                                @click="deleteFn(index, item.id)"
                                class="icon-close"
                            ></span>
                          </div>
                        </div>
                      </el-form-item>
                      <el-form-item label="展示封面">
                        <div style="display: flex">
                          <div
                              class="one-box one-box-two"
                              @click="openChooseCover"
                          >
                            <div v-if="!coverImg">
                              <span class="icon-plus"></span>
                              <div class="text">点击上传图片</div>
                            </div>
                            <div class="img-box" v-if="coverImg">
                              <div class="semi-close" @click.stop="deleteImg">
                                <span class="icon-semi-close"></span>
                              </div>
                              <img class="add-img" :src="imgIp + coverImg"/>
                              <div class="edit-image" @click="toEditImg">
                                替换 编辑
                              </div>
                            </div>
                          </div>
                          <!-- <div class="one-box one-box-two" v-for="(item,index) in coverImgList" :key="index">
                                              <div class="semi-close" @click="deleteImg(item,index)">
                                                  <span class="icon-semi-close"></span>
                                              </div>
                                              <img class="add-img" :src="imgIp +item" />
                                              <div class="edit-image" @click="toEditImg(item,index )">替换 编辑</div>
                                          </div> -->
                        </div>
                        <div
                            style="font-size: 12px; margin-top: 0px; color: #909399"
                        >
                          支持20MB以内的jpg、png、gif 图片
                        </div>
                      </el-form-item>
                      <el-form-item class="link-box" v-if="codeData.indexOf('182') != -1" label="相关链接">
                        <el-button @click="openChooseLink">+添加链接</el-button>
                        <div>
                          <div
                              v-for="(item, index) in LinkInfo"
                              class="one"
                              :key="index"
                          >
                            <div class="name">
                              <div  v-if="item.state == 4" class="title-box">
                                已发布
                              </div>
                               <div
                                style="background-color: rgba(179, 183, 190, 1)"
                                v-if="item.state == 5"
                                class="title-box"
                              >
                                已下线
                              </div>
                              <div v-if="item.linkUrl" class="title-box">自定义</div>
                              <div class="link-txt"><span :title="item.title">{{ item.title }}</span></div>
                            </div>
                            &emsp;
                            <span
                                @click="deleteLinks(index)"
                                class="icon-close"
                            ></span>
                          </div>
                        </div>
                      </el-form-item>
                      <div id="keyword">
                      <el-form-item label="关键词" prop="keyword">
                        <el-input
                            placeholder="多个关键词,以‘,’隔开"
                            v-model="keyword"
                        >
                          <div
                              slot="append"
                              @click="getKeyWords"
                              style="cursor: pointer"
                          >
                            识别关键词
                          </div>
                        </el-input>
                      </el-form-item>
                      </div>
                      <el-form-item label="重定向" prop="redirectUrl">
                        <el-input
                            placeholder="请输入目标url地址"
                            v-model="redirectUrl"
                        >
                        </el-input>
                        <div
                            style="font-size: 12px; margin-top: 0px; color: #909399"
                        >
                          设置重定向地址后，当前稿件正文内容将不再显示，网站页面将跳转至目标地址
                        </div>
                      </el-form-item>
                    </el-form>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="right">
            <div class="tabs-box">
              <div @click="changeType(1)" class="menhu">
                <img src="@/assets/images/wangzhan.jpg"/>
                <div style="min-width:56px">门户网站</div>
                <div v-if="tabsType == 1" class="tabs-dir"></div>
              </div>
              <div v-if="codeData.indexOf('243') != -1" @click="changeType(2)" class="menhu">
                <img src="@/assets/images/weixin.png"/>
                <div>公众号</div>
                <div v-if="tabsType == 2" class="tabs-dir"></div>
              </div>
              <!-- <div @click="changeType(3)" class="menhu">
                <img src="@/assets/images/toutiao.png" />
                <div>头条号</div>
                <div v-if="tabsType == 3" class="tabs-dir"></div>
              </div> -->
              <div @click="changeType(4)" class="menhu">
                <img src="@/assets/images/weibo.png"/>
                <div>微博号</div>
                <div v-if="tabsType == 4" class="tabs-dir"></div>
              </div>
            </div>
            <el-form
                ref="form"
                style="padding: 0 20px; font-size: 14px; background: #fff;padding-bottom:100px"
                v-if="tabsType == 1"
            >
              <div v-for="(item, index) in ModelColumns" :key="index">
                <div
                    style="
                  padding: 0 20px;
                  font-weight: bold;
                  font-size: 15px;
                  margin: 20px 0;
                "
                >
                  {{ item.modelName }}
                </div>
                <div v-if="
                  item.fieldResponse.indexRequests &&
                  item.fieldResponse.indexRequests.length > 0
                ">
                  <el-form-item
                      v-for="(column, columnIndex) in item.fieldResponse.indexRequests"
                      :key="columnIndex"
                  >
                    <div class="item-box-one">
                      <div class="label-box">
                      <span v-if="column.flagRequired == 0" style="color: red"
                      >*</span
                      >
                        <span>{{ column.textName }}</span>
                      </div>
                      <div style="width: 100%">
                        <el-input
                            v-model="column.content"
                            :placeholder="column.tips"
                        ></el-input>
                        <div
                            class="item-error"
                            v-if="!column.content && column.flagRequired == 0"
                        >
                          必填
                        </div>
                      </div>
                    </div>
                  </el-form-item>
                </div>
                <div
                    v-if="
                  item.fieldResponse.fieldTextCreateRequests &&
                  item.fieldResponse.fieldTextCreateRequests.length > 0
                "
                >
                  <el-form-item
                      v-for="(column, columnIndex) in item.fieldResponse
                    .fieldTextCreateRequests"
                      :key="columnIndex"
                  >
                    <div class="item-box-one">
                      <div class="label-box">
                      <span v-if="column.flagRequired == 0" style="color: red"
                      >*</span
                      >
                        <span>{{ column.textName }}</span>
                      </div>
                      <div style="width: 100%">
                        <el-input
                            v-model="column.content"
                            v-if="column.type == 0 && column.wordLimit"
                            :placeholder="column.tips"
                            :maxlength="column.wordLimit"
                        ></el-input>
                        <el-input
                            v-model="column.content"
                            v-if="column.type == 0 && column.wordLimit == 0"
                            :placeholder="column.tips"
                        ></el-input>
                        <el-input
                            type="textarea"
                            :rows="2"
                            :placeholder="column.tips"
                            v-model="column.content"
                            :maxlength="column.wordLimit"
                            v-if="column.type == 1 && column.wordLimit"
                        >
                        </el-input>
                        <el-input
                            type="textarea"
                            :rows="2"
                            :placeholder="column.tips"
                            v-model="column.content"
                            v-if="column.type == 1 && column.wordLimit == 0"
                        >
                        </el-input>
                        <div
                            class="item-error"
                            v-if="!column.content && column.flagRequired == 0"
                        >
                          必填
                        </div>
                        <div
                            class="item-error"
                            v-if="
                          column.content && column.wordLimit &&
                          column.content.length > column.wordLimit
                        "
                        >
                          最多{{ column.wordLimit }}字
                        </div>
                        <div
                            class="item-error"
                            v-if="column.content && textFn(column)"
                        >
                          {{ textFn(column) }}
                        </div>
                      </div>
                    </div>
                  </el-form-item>
                </div>
                <div
                    v-if="
                  item.fieldResponse.fieldOptionCreateRequests &&
                  item.fieldResponse.fieldOptionCreateRequests.length > 0
                "
                >
                  <el-form-item
                      v-for="(column, columnIndex) in item.fieldResponse
                    .fieldOptionCreateRequests"
                      :key="columnIndex"
                  >
                    <div style="width: 100%" class="item-box-one">
                      <div class="label-box">
                      <span v-if="column.flagRequired == 0" style="color: red"
                      >*</span
                      >
                        <span>{{ column.textName }}</span>
                      </div>
                      <div style="width: 100%">
                        <el-radio-group
                            v-model="column.content"
                            v-if="column.type == 0"
                             class="radio-box"
                        >
                          <el-radio
                              :label="option.id"
                              v-for="(option, optionIndex) in column.optionContents"
                              :key="optionIndex"
                          >{{ option.content }}
                          </el-radio
                          >
                        </el-radio-group>
                        <el-checkbox-group
                            v-model="column.content"
                            v-if="column.type == 1"
                        >
                          <el-checkbox
                              v-for="(option, optionIndex) in column.optionContents"
                              :label="option.id"
                              :key="optionIndex"
                          >{{ option.content }}
                          </el-checkbox
                          >
                        </el-checkbox-group>
                        <el-select
                            v-model="column.content"
                            v-if="column.type == 2"
                        >
                          <el-option
                              :label="option.content"
                              :value="option.id"
                              v-for="(option, optionIndex) in column.optionContents"
                              :key="optionIndex"
                          ></el-option>
                        </el-select>
                        <div
                            class="item-error"
                            v-if="!column.content && column.flagRequired == 0 && column.type != 1"
                        >
                          必填
                        </div>
                        <div
                            class="item-error"
                            v-if="(!column.content || (column.content && column.content.length == 0)) && column.flagRequired == 0 && column.type == 1"
                        >
                          必填
                        </div>

                      </div>
                    </div>
                  </el-form-item>
                </div>
                <div
                    v-if="
                  item.fieldResponse.dateCreateRequest &&
                  item.fieldResponse.dateCreateRequest.length > 0
                "
                >
                  <el-form-item
                      v-for="(column, columnIndex) in item.fieldResponse
                    .dateCreateRequest"
                      :key="columnIndex"
                  >
                    <div class="item-box-one">
                      <div class="label-box">
                      <span v-if="column.flagRequired == 0" style="color: red"
                      >*</span
                      >
                        <span>{{ column.textName }}</span>
                      </div>
                      <div style="width: 100%">
                        <el-date-picker
                            v-model="column.content"
                            type="date"
                            style="width: 100%"
                            placeholder="选择日期"
                            v-if="column.dateType == 0"
                            :picker-options="pickerOptions"
                            @input="changeTime"
                        ></el-date-picker>
                        <el-time-picker
                            v-model="column.content"
                            style="width: 100%"
                            v-if="column.dateType == 1"
                            :picker-options="{
                          selectableRange:'18:30:00 - 20:30:00'
                         }"
                            @input="changeTime"
                        >
                        </el-time-picker>
                        <el-date-picker
                            v-model="column.content"
                            type="datetime"
                            style="width: 100%"
                            v-if="column.dateType == 2"
                            @input="changeTime"
                        ></el-date-picker>
                        <div
                            class="item-error"
                            v-if="!column.content && column.flagRequired == 0"
                        >
                          必填
                        </div>
                      </div>
                    </div>
                  </el-form-item>
                </div>
                <div
                    v-if="
                  item.fieldResponse.fieldFileCreateRequests &&
                  item.fieldResponse.fieldFileCreateRequests.length > 0
                "
                >
                  <el-form-item
                      :label="column.textName"
                      v-for="(column, columnIndex) in item.fieldResponse
                    .fieldFileCreateRequests"
                      :key="columnIndex"
                  >
                    <div>
                      <el-upload
                          :show-file-list="false"
                          class="dantu-upload"
                          :before-upload="
                      (file) =>
                        beforeUpload(file, index, columnIndex, column, 0)
                    "
                          action="#"
                          list-type="picture-card"
                          :multiple="false"
                          v-if="column.type == 0"
                      >
                        <img
                            v-if="imgUrlList[index] && imgUrlList[index][columnIndex + 'url'][0] && imgUrlList[index][columnIndex + 'url'][0].path"
                            :src="imgIp + imgUrlList[index][columnIndex + 'url'][0].path"
                            class="el-upload-list__item-thumbnail"
                        />
                        <i class="el-icon-plus" v-else></i>
                        <div class="dantu-yan item-error"
                             v-if="(!imgUrlList[index] || (imgUrlList[index] && !imgUrlList[index][columnIndex + 'url'])) && column.flagRequired == 0"
                             style="margin-right:10px">必填
                        </div>
                      </el-upload>
                    </div>
                    <a-upload
                        multiple
                        :file-list="moreImgUrlList[column.id + column.type]"
                        :before-upload="
                      (file, fileList) =>
                        beforeUpload(
                          file,
                          index,
                          columnIndex,
                          column,
                          1,
                          fileList
                        )
                    "
                        style="margin-left: 20px;"
                        v-if="column.type == 1"
                        :remove="
                      (file) => removeImg(file, index, columnIndex, column, 1)
                    "
                    >
                      <el-button size="small" type="primary"
                      ><img
                          class="add-img"
                          src="@/assets/images/add.jpg"
                      />上传图片
                      </el-button
                      >
                      <div
                          v-if="(!fileListTwo[column.id + column.type] || (fileListTwo[column.id + column.type] && fileListTwo[column.id + column.type].length == 0)) && column.flagRequired == 0"
                          style="margin-right:10px" class="item-error">必填
                      </div>
                    </a-upload>
                    <!-- <a-upload list-type="picture-card" :before-upload="(file,fileList)=>beforeUpload(file,fileList,index,columnIndex,column,1)" v-if="column.type==1">
                                                  <el-button size="small" type="primary"></el-button>
                                              </a-upload> -->
                    <!-- <a-upload v-model="fileList"
                                                  action="#"
                                                  list-type="picture-card"
                                                  :before-upload="(file,fileList)=>beforeUpload(file,fileList,index,columnIndex,column,1)" v-if="column.type==1">
                                                  <div v-if="fileList.length < 8">
                                                      <span class="icon-plus"> </span>
                                                      <div style="margin-top: 8px">点击上传图片</div>
                                                  </div>
                                              </a-upload> -->
                    <a-upload
                        :file-list="vidioList[column.id + column.type]"
                        :before-upload="
                      (file) =>
                        beforeUpload(file, index, columnIndex, column, 2)
                    "
                        style="margin-left: 20px"
                        v-if="column.type == 2"
                        :remove="
                      (file) => removeVideo(file, index, columnIndex, column, 2)
                    "
                    >
                      <el-button size="small" type="primary"
                      ><img
                          class="add-img"
                          src="@/assets/images/add.jpg"
                      />上传视频
                      </el-button
                      >
                      <div
                          v-if="(!fileListTwoVideo[column.id + column.type] || (fileListTwoVideo[column.id + column.type] && fileListTwoVideo[column.id + column.type].length == 0)) && column.flagRequired == 0"
                          style="margin-right:10px" class="item-error">必填
                      </div>
                    </a-upload>
                    <a-upload
                        :file-list="mp3List[column.id + column.type]"
                        :before-upload="
                      (file) =>
                        beforeUpload(file, index, columnIndex, column, 3)
                    "
                        style="margin-left: 20px"
                        v-if="column.type == 3"
                        :remove="
                      (file) => removeMp3(file, index, columnIndex, column, 3)
                    "
                    >
                      <el-button size="small" type="primary"
                      ><img
                          class="add-img"
                          src="@/assets/images/add.jpg"
                      />上传音频
                      </el-button
                      >
                      <div
                          v-if="(!fileListTwoMp3[column.id + column.type] || (fileListTwoMp3[column.id + column.type] && fileListTwoMp3[column.id + column.type].length == 0)) && column.flagRequired == 0"
                          style="margin-right:10px" class="item-error">必填
                      </div>
                    </a-upload>
                    <a-upload
                        :file-list="fileList[column.id + column.type]"
                        :before-upload="
                      (file) =>
                        beforeUpload(file, index, columnIndex, column, 4)
                    "
                        style="margin-left: 20px"
                        v-if="column.type == 4"
                        :remove="
                      (file) => removeFile(file, index, columnIndex, column, 4)
                    "
                    >
                      <el-button size="small" type="primary"
                      ><img
                          class="add-img"
                          src="@/assets/images/add.jpg"
                      />上传附件
                      </el-button
                      >
                      <div
                          v-if="(!fileListTwoFile[column.id + column.type] || (fileListTwoFile[column.id + column.type] && fileListTwoFile[column.id + column.type].length == 0)) && column.flagRequired == 0"
                          style="margin-left:10px;margin-top:10px" class="item-error">必填
                      </div>
                    </a-upload>
                  </el-form-item>
                </div>
                <div
                    style="
                  height: 2px;
                  width: 90%;
                  background: #f0f2f5;
                  margin: 0 auto;
                "
                ></div>
              </div>
            </el-form>
            <div v-if="tabsType == 2 && codeData.indexOf('243') != -1">
              <div style="padding: 20px">
                <el-button @click="selectWeiXin" type="primary">+选择公众号</el-button>
                <div v-for="(newItem,index) in newSelectData" class="acc-list">
                  <div>{{ newItem.nickName || newItem.name }}</div>
                  <span @click="weiXinDel(index)" class="icon-close new-close"></span>
                </div>
              </div>
              <div class="set-title">
                <div class="line" style="width: 30%"></div>
                公众号发布设置
                <div class="line" style="width: 30%"></div>
              </div>
              <div style="max-width: 380px;margin: 20px auto 0;font-size: 14px;line-height: 24px;color: #909399;">
                （1）说明<br/>
                1. 通过综合信息平台推送公众号，微信服务号每月可发布4条，微信订阅号每天可发布1条；<br/>
                2. 审核通过后，需至“我的稿件”或“稿件库”页面，在关联新媒体中点击发布才能发布成功。<br/>
<!--                （2）新媒体展示封面选项调整<br/>-->
<!--                1. 默认状态下，使用已有封面和单独上传两个选项未选择，且不显示图片上传框；<br/>-->
<!--                2. 选择使用已有封面，若当前稿件有封面，则在图片上传框位置显示封面，若当前稿件无封面，则提示“请在稿件发文设置中添加展示封面后再选择”，此时“使用已有封面”选项仍未选中；<br/>-->
<!--                3. 选择单独上传时，显示图片上传框；<br/>-->
<!--                4. 若单独上传并选择图片后，选择使用已有封面，若稿件有封面则切换选项并显示稿件封面，若无则不切换并按第2点提示，切换后再切换回单独上传，之前上传的图片需保留显示-->
              </div>
              <el-form
                  ref="form"
                  label-width="68px"
                  style="padding: 0 20px; margin: 20px 0;background:#fff"
              >
                <el-form-item label="展示封面">
                  <el-radio-group v-model="weiForm.imgType" @change="radioChange">
                    <el-radio :label="1">使用已有封面</el-radio>
                    <el-radio :label="2">单独上传</el-radio>
                  </el-radio-group>
                  <a-upload
                      name="avatar"
                      list-type="picture-card"
                      class="avatar-uploader"
                      :show-upload-list="false"
                      :before-upload="beforeUploadNewWei"
                      v-if="weiForm.imgType===2"
                  >
                    <img style="width:100%;height:100%" v-if="weiForm.imgUrl" :src="imgIp + weiForm.imgUrl"
                         alt="avatar"/>
                    <div v-else>
                      <a-icon :type="loading ? 'loading' : 'plus'"/>
                      <div class="ant-upload-text">点击上传图片</div>
                    </div>
                  </a-upload>
                  <div style="font-size: 12px; margin-top: -24px" v-if="weiForm.imgType===2">
                    支持20MB以内的jpg、png图片
                  </div>
                </el-form-item>
                <el-form-item label="独立标题">
                  <el-input v-model="weiForm.title"></el-input>
                  <div
                      style="font-size: 12px; margin-top: 0px"
                      placeholder="选填"
                  >
                    若标题为空,则使用文章标题
                  </div>
                </el-form-item>
                <el-form-item label="原文链接">
                  <el-input v-model="weiForm.links"></el-input>
                  <div style="font-size: 12px; margin-top: 0px">
                    请勿添加其他公众号的主页链接
                  </div>
                </el-form-item>
              </el-form>
            </div>
            <div v-if="tabsType == 3">
              <div style="padding: 20px">
                <el-button type="primary">+选择头条号</el-button>
                <div class="acc-list">
                  <div>甘孜州人民政府</div>
                  <span class="icon-close"></span>
                </div>
              </div>
              <div class="set-title">
                <div class="line" style="width: 30%"></div>
                头条号发布设置
                <div class="line" style="width: 30%"></div>
              </div>
              <el-form
                  ref="form"
                  label-width="68px"
                  style="padding: 0 20px; margin: 20px 0"
              >
                <el-form-item label="展示封面">
                  <el-radio-group>
                    <el-radio label="使用已有封面"></el-radio>
                    <el-radio label="单独上传"></el-radio>
                  </el-radio-group>
                  <a-upload
                      name="avatar"
                      list-type="picture-card"
                      class="avatar-uploader"
                      :show-upload-list="false"
                      action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
                      :before-upload="beforeUpload"
                      @change="handleChange"
                  >
                    <img v-if="imageUrl" :src="imageUrl" alt="avatar"/>
                    <div v-else>
                      <a-icon :type="loading ? 'loading' : 'plus'"/>
                      <div class="ant-upload-text">点击上传图片</div>
                    </div>
                  </a-upload>
                  <div style="font-size: 12px; margin-top: -24px">
                    支持5m以内的jpg、png图片
                  </div>
                </el-form-item>
                <el-form-item label="独立标题">
                  <el-input></el-input>
                  <div
                      style="font-size: 12px; margin-top: 0px"
                      placeholder="选填"
                  >
                    若标题为空,则使用文章标题
                  </div>
                </el-form-item>
                <el-form-item label="原文链接">
                  <el-input></el-input>
                  <div style="font-size: 12px; margin-top: 0px">
                    请勿添加其他公众号的主页链接
                  </div>
                </el-form-item>
              </el-form>
            </div>
            <div v-if="tabsType == 4">
              <div style="padding: 20px">
                <el-button @click="selectWeiBo" type="primary">+选择微博号</el-button>
                <div v-for="(newItem,index) in sinaWeiBoData" class="acc-list">
                  <div>{{ newItem.screenName || newItem.name }}</div>
                  <span @click="weiBoDel(index)" class="icon-close new-close"></span>
                </div>
              </div>
              <div class="set-title">
                <div class="line" style="width: 30%"></div>
                微博号发布设置
                <div class="line" style="width: 30%"></div>
              </div>
              <el-form
                  ref="form"
                  label-width="68px"
                  style="padding: 0 20px; margin: 20px 0;background:#fff"
              >
                <el-form-item label="展示封面">
                  <el-radio-group v-model="weiBoForm.imgType">
                    <el-radio :label="1">使用已有封面</el-radio>
                    <el-radio :label="2">单独上传</el-radio>
                  </el-radio-group>
                  <a-upload
                      name="avatar"
                      list-type="picture-card"
                      class="avatar-uploader"
                      :show-upload-list="false"
                      action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
                      :before-upload="beforeUploadWeiBo"
                  >
                    <img style="width:100%;height:100%" v-if="weiBoForm.imgUrl" :src="imgIp + weiBoForm.imgUrl"
                         alt="avatar"/>
                    <div v-else>
                      <a-icon :type="loading ? 'loading' : 'plus'"/>
                      <div class="ant-upload-text">点击上传图片</div>
                    </div>
                  </a-upload>
                  <div style="font-size: 12px; margin-top: -24px">
                    支持20MB以内的jpg、png图片
                  </div>
                </el-form-item>
                <el-form-item label="短微博">
                  <el-input type="textarea" v-model="weiBoForm.title" :rows="2" placeholder="多行输入">
                  </el-input>
                  <div
                      style="font-size: 12px; margin-top: 0px"
                      placeholder="选填"
                  >
                    与文章绑定微博内容
                  </div>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </div>
      </a-spin>
      <div v-if="btnShow" class="setup-bt">
        <div class="setup-bt-one"></div>
        <div class="setup-bt-btn">
          <div class="doc-set">
            <span>正文字数：{{ htmlContentCount }}</span
            >&emsp;
            <!-- <a href="#setup" v-if="pageLocation==1" @click="pageLocation=2">发文设置<span class="icon-expand_more"></span></a> -->
            <a v-if="!isEdit" @click="editTxt" style="color: #415058"
            >发文设置
              <a-icon type="down"
              />
            </a>
            <a v-if="isEdit" @click="editTxtTwo" style="color: #415058"
            >正文编辑
              <a-icon type="up"
              />
            </a>
          </div>
          <div class="btn-box" style="display: flex">
            <div class="doc-set">
              <el-button class="cg-box" :disabled="loadingBox" v-if="codeData.indexOf('154') != -1" :loading="loading"
                         @click="saveManuscript(1)"
              >保存草稿
              </el-button
              >
            </div>
            <el-button
                type="primary"
                plain
                size="medium"
                :disabled="loadingBox"
                :loading="loadingThree"
                @click="saveManuscript(3)"
                v-if="codeData.indexOf('179') != -1"
            >
              预览
            </el-button
            >
            <el-button
                type="primary"
                plain
                size="medium "
                :disabled="loadingBox"
                :loading="loadingFour"
                @click="saveManuscript(4)"
                v-if="codeData.indexOf('179') != -1"
            >
             提交并新建
            </el-button
            >
            <el-button
                :disabled="loadingBox"
                v-if="codeData.indexOf('155') != -1"
                :loading="loadingTwo"
                type="primary"
                size="medium "
                @click="saveManuscript(2)"
            >提交审核
            </el-button
            >
          </div>
        </div>
        <div class="setup-bt-two"></div>
      </div>

    </div>

    <a-modal
        title="选择文件"
        :visible="importIsShow"
        @cancel="closeImport"
        centered
        width="500px"
        heigth="500px"
        class="import"
        @ok="importWord"
    >
      <div>
        <div class="tips">
          <span class="icon-info"></span>&nbsp;导入文件后，现有正文内容将被删除
        </div>
        <div>
          <a-upload-dragger
              name="file"
              :multiple="false"
              action="#"
              :fileList="fileListExple"
              :before-upload="beforeUploadFile"
              :remove="remove"
          >
            <div v-if="importType == 1">
              <p class="ant-upload-drag-icon">
                <span class="icon-edit-word"></span>
              </p>
              <a-button> 选择文件</a-button>
              <p class="ant-upload-hint">
                可直接将文件拖拽到此处进行上传，支持格式：doc、docx
              </p>
            </div>
            <div v-if="importType == 2">
              <p class="ant-upload-drag-icon">
                <span class="icon-edit-excel"></span>
              </p>
              <a-button> 选择文件</a-button>
              <p class="ant-upload-hint">
                可直接将文件拖拽到此处进行上传，支持格式：xls、xlsx
              </p>
            </div>
            <div v-if="importType == 3">
              <p class="ant-upload-drag-icon">
                <span class="icon-edit-pdf"></span>
              </p>
              <a-button> 选择文件</a-button>
              <p class="ant-upload-hint">
                可直接将文件拖拽到此处进行上传，支持格式：pdf
              </p>
            </div>
            <div v-if="importType == 4">
              <p class="ant-upload-drag-icon">
                <span class="icon-edit-ppt"></span>
              </p>
              <a-button> 选择文件</a-button>
              <p class="ant-upload-hint">
                可直接将文件拖拽到此处进行上传，支持格式：ppt、pptx
              </p>
            </div>
          </a-upload-dragger>
        </div>
      </div>
    </a-modal>
    <choose-cover
        :resourceIsShow="resourceIsShow"
        @colseChooseCover="colseChooseCover"
        ref="chooseCover"
        @setCoverImg="setCoverImg"
    ></choose-cover>
    <choose-column
        :isColumn="isColumn"
        @colseChooseColumn="colseChooseColumn"
        @setColumnIds="setColumnIds"
        ref="chooseColumn"
        :columnData="columnData"
        :selectedKeys="[]"
    ></choose-column>
    <choose-link
        :isLink="isLink"
        v-if="isLink"
        @colseChooseLink="colseChooseLink"
        ref="chooseLink"
        @setLinkIds="setLinkIds"
        @openLink="openLink"
    ></choose-link>
    <missensitivity
        :misseIsShow="misseIsShow"
        @closeMisse="closeMisse"
        :title="title"
        :abstractText="abstractText"
        :content="htmlContent"
        @saveMisse="saveMisse"
        v-if="misseIsShow"
        ref="missensity"
    ></missensitivity>
    <dark-link-detection
        :darkLinkShow="darkLinkShow"
        v-if="darkLinkShow"
        @closeMisse="closeDarkLink"
        :editorHtml="editorHtml"
        @removeLink="removeLink"
    ></dark-link-detection>
    <div id="editerHtml" v-show="false" v-html="editorData"></div>
    <selectWei :newSelectData="newSelectData" @newMedia="newMedia" v-if="isShowWei" :isShowWei="isShowWei"
               @selectCloseWei="selectCloseWei"/>
    <selectWeiBo :newSelectData="sinaWeiBoData" @newMediaWeiBo="newMediaWeiBo" v-if="isShowWeiBo"
                 :isShowWeiBo="isShowWeiBo" @selectCloseWeiBo="selectCloseWeiBo"/>
    <el-dialog
        title="链接导入"
        :visible.sync="linkImportShow"
        width="535px"
        class="column-box"
        :before-close="handleCloseColum"
        top="12%"
    >
      <div class="colum-title-box">
        <i style="margin-right: 8px;" class="el-icon-info"></i
        >导入文件后，现有正文内容将被删除
      </div>
      <el-form
          ref="ruleForm"
          label-width="100px"
          class="demo-ruleForm"
          :rules="ruleLink"
          :model="linkTxtForm"
      >
        <el-form-item label="目标链接" prop="linkTxt">
          <el-input
              v-model="linkTxtForm.linkTxt"
              placeholder="请输入目标链接"
          ></el-input>
          <div style="color:#ccc">已支持中国政府网、四川省人民政府网站的文章导入</div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
    <el-button @click="linkImportShow = false">取 消</el-button>
    <el-button :loading="loadingBtn" type="primary" @click="replaceResults">导入</el-button>
  </span>
    </el-dialog>
    <el-dialog
        :visible.sync="isDetected"
        title="提示"
        width="500px">
      <span>是否进行错敏检测</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="isDetected = false;detected = true">否</el-button>
        <el-button type="primary" @click="openMisse">是</el-button>
    </span>
    </el-dialog>

    <a-modal
        title="选择模板"
        :visible="templateShow"
        @cancel="templateShow = false"
        centered
        width="500px"
        heigth="500px"
        class="template_modal"
    >
      <div>
        <div class="tips">
          <span class="icon-info"></span>&nbsp;使用模板后，现有正文内容将被删除
        </div>
        <div class="item" v-for="item in reportTemplate" :key="item.id">
          <p>{{ item.name }}</p>
          <span style="color:#1890FF;cursor: pointer" @click="insertTemp(item)">使用模板</span>
        </div>
      </div>
    </a-modal>

  </div>


</template>

<script>
// import {Editor, Toolbar} from "@wangeditor/editor-for-vue";
import uEditorWrap from "vue-ueditor-wrap";
import {Loading} from "element-ui";
import {
  selectModelByColumnId,
  createManuscript,
  uploadFile,
  createDraft,
  importWordToHtml,
  importExcelToHtml,
  importPdfToHtml,
  importPptToHtml,
  keyWordsExtract,
  previewManuscript,
  getIndexNumber,
  importUrlToHtml
} from "./manuscripts.js";
import {uploadImg, uploadVideo} from "@/utils/common.js";
import chooseCover from "./chooseCover.vue";
import chooseColumn from "./choose_column.vue";
import chooseLink from "./choose_link.vue";
import missensitivity from "./missensitivity.vue";
import darkLinkDetection from "./darkLinkDetection.vue";
import {message} from "ant-design-vue";
import juice from "juice";
import selectWei from './select_wei.vue';
import selectWeiBo from './select_weiBo.vue';
import {SlateTransforms} from '@wangeditor/editor';
import MonitorKeyboard from '@/utils/monitorKeyboard.js';
import {reportTemplate} from "./template/index";

export default {
  components: {
    // Editor,
    // Toolbar,
    chooseCover,
    chooseColumn,
    chooseLink,
    missensitivity,
    darkLinkDetection,
    selectWei,
    selectWeiBo,
    uEditorWrap
  },
  data() {
    let self = this;
    return {
      uEditorConfig: {
        // 配置UEditorPlus的惊天资源
        UEDITOR_HOME_URL: process.env.VUE_APP_Admin || '/admin/static/uEditor/',
        UEDITOR_CORS_URL: process.env.VUE_APP_Admin || '/admin/static/uEditor/',
        // 服务器统一请求接口路径
        serverUrl: process.env.VUE_APP_BASE_URL + "/site-service/m/cover/uploadImage"
        // 启用拖放上传
        , enableDragUpload: true
        // 启用粘贴上传
        , enablePasteUpload: true
        // 启用图片拉伸缩放
        , imageScaleEnabled: true
      },
      reportTemplate:reportTemplate,
      loadServe:null,
      editor: null,
      monitorKeyboard:'',
      jsonContent: [
        {
          type: 'paragraph',
          lineHeight: '1.5',
          children: [
            {text: '', fontFamily: '宋体', fontSize: '18px'}
          ]
        },
      ],
      templateShow: false,
      editorData: "",
      loadingBox: false,
      btnShow:true,
      height: 0,
      isShowWei: false,
      fileListExple: [],
      toolbarConfig: "",
      htmlContent: "",
      isShowWeiBo: false,
      loadingThree: false,
      editorConfig: {
        placeholder: "请输入正文",
        pasteFilterStyle: false,
        hoverbarKeys: {
          attachment: {
            menuKeys: ["downloadAttachment"], // “下载附件”菜单
          },
        },
        MENU_CONF: {
          uploadAttachment: {
            // 用户自定义上传
            customUpload(file, insertFn) {
              self.loadingBox = true;
              uploadImg(file, "fujian").then((res) => {
                self.loadingBox = false;
                var encodedData = window.btoa(
                    process.env.VUE_APP_Img_Ip + res.path
                ); // 编码
                let url =
                    `${process.env.VUE_APP_Preview}?url=` + encodedData;
                insertFn(`${file.name}`, url);
              });
            },
          },
          fontFamily: {
            fontFamilyList: [
              "仿宋_GB2312",
              "黑体",
              "仿宋",
              "楷体",
              "标楷体",
              "华文仿宋",
              "华文楷体",
              "宋体",
              "微软雅黑",
              "Arial",
              "Tahoma",
              "Verdana",
              "Times New Roman",
              "Courier New",
            ],
          },
          pasteFilterStyle: false,
          uploadImage: {
            server:
                `${process.env.VUE_APP_BASE_URL}/site-service/m/cover/uploadImage`,
            fieldName: "file",
            maxFileSize: 100 * 1024 * 1024,
            meta: {
              type: "img",
            },
            headers: {
              token: sessionStorage.getItem("token"),
            },
            customInsert: this.customInsert,
            onProgress(progress) {  // TS 语法
              self.loadingBox = true;
            },
            onSuccess(file, res) {  // TS 语法
              self.loadingBox = false;
            },
            onFailed(file, res) {
              self.loadingBox = false;
            },
          },
          fontSize: {
            fontSizeList: [
              {name: '初号', value: '56px'},
              {name: '小初', value: '48px'},
              {name: '一号', value: '34px'},
              {name: '小一', value: '32px'},
              {name: '二号', value: '29px'},
              {name: '小二', value: '24px'},
              {name: '三号', value: '21px'},
              {name: '小三', value: '20px'},
              {name: '四号', value: '18px'},
              {name: '小四', value: '16px'},
              {name: '五号', value: '14px'},
              {name: '小五', value: '12px'},
            ]
          },
          lineHeight: {
            lineHeightList: ['1', '1.5', '2', '2.5', '3']
          },
          // uploadVideo: {
          //   server:
          //     `${process.env.VUE_APP_BASE_URL}/site-service/m/cover/uploadImage`,
          //   fieldName: "file",
          //   maxFileSize:100* 1024 * 1024 * 1024,
          //   timeout: 60 * 60 * 1000,
          //   // 上传错误，或者触发 timeout 超时
          //   onError(file, err, res) {  // TS 语法
          //   // onError(file, err, res) {               // JS 语法
          //       console.log(`${file.name} 上传出错`, err, res)
          //   },
          //   // 单个文件上传成功之后
          //   onSuccess(file, res) {  // TS 语法
          //        self.loadingBox = false;
          //       console.log(`${file.name} 上传成功`, res)
          //   },
          //   onBeforeUpload(file) {   // TS 语法
          //         return file
          //     },
          //      onProgress(progress) {  // TS 语法
          //         self.loadingBox = true;
          //     },
          //   meta: {
          //     type: "video",
          //   },
          //   headers: {
          //     token: sessionStorage.getItem("token"),
          //   },
          //   customInsert: this.customInsert,
          // },
          uploadVideo: {
            maxFileSize: 100 * 1024 * 1024 * 1024,
            timeout: 60 * 60 * 1000,
            customUpload(file, insertFn) {  // TS 语法
              self.loadingBox = true;
              uploadVideo(file, "video").then((res) => {
                if (res.video.path) {
                  self.loadingBox = false;
                  insertFn(self.imgIp + res.video.path, self.imgIp + res.image.path)
                }
              });

            }
          }
        },
      },
      mode: "default", // or 'simple'
      title: "",
      createTime: new Date(),
      source: "",
      abstractText: "",
      modelId: "", //栏目管理的模型id
      keyword: "",
      redirectUrl: "", //重定向url
      sizeForm: {},
      imageUrl: "",
      loading: false,
      ruleForm: {},
      activeName: "first",
      ModelColumns: [],
      resourceIsShow: false, //上传图片及资源列表界面
      isColumn: false, //选择栏目界面
      isLink: false,
      isLodaing: false,
      imgUrlList: [], //单图路径
      moreImgUrlList: [], //多图上传路径
      vidioList: [], //视频文件路劲
      mp3List: [], //音频文件路径
      fileList: [], //文件路径
      coverImg: "", //文章封面图
      columnIds: [], //选中的栏目id
      columnData: [], //选中的栏目数据
      LinkIds: [], //选中的链接id
      LinkInfo: [], //选中的链接数据
      pageLocation: 1,
      loadingTwo: false,
      loadingFour: false,
      misseIsShow: false,
      darkLinkShow: false,
      htmlContentCount: 0, //字数
      importIsShow: false,
      importFile: {},
      importType: 1, //1 word导入 2 Excel导入 3 PDF导入 4 ppt导入
      tabsType: 1,
      fileListTwo: [],
      fileListTwoVideo: [],
      fileListTwoMp3: [],
      fileListTwoFile: [],
      newSelectData: [],
      sinaWeiBoData: [],
      weiForm: {
        type: 1,
        title: '',
        links: '',
        imgUrl: '',
        imgType: '',
      },
      weiBoForm: {
        type: 2,
        title: '',
        links: '',
        imgUrl: '',
        imgType: '',
      },
      codeData: [],
      linkImportShow: false,
      ruleLink: {
        linkTxt: [
          {
            required: true,
            message: "请输入链接",
            trigger: "blur"
          }
        ]
      },
      linkTxtForm: {
        linkTxt: '',
      },
      loadingBtn: false,
      editorHtml: '',
      isEdit: false,
      pickerOptions: {
        // disabledDate(time) {
        // return time.getTime() > Date.now();
        // },
        shortcuts: [{
          text: '2999-12-31',
          onClick(picker) {
            picker.$emit('pick', new Date('2999-12-31'));
          }
        },
        ]
      },
      detected: false,
      isDetected: false,

      noFirst:false,
    };
  },
  filters: {
    arr(item) {
      return [];
    },
  },
  mounted() {
    this.codeData = JSON.parse(sessionStorage.getItem('menuData'))
    this.toolbarConfig = {
      excludeKeys: ["todo", "emotion"],
      insertKeys: {
        index: 2, // 自定义插入的位置
        keys: ["uploadAttachment"], // “上传附件”菜单
      },
    };
    this.height = document.documentElement.clientHeight - 112 + "px";
    window.onresize = () => {
      return (() => {
        this.height = document.documentElement.clientHeight - 112 + "px";
      })();
    };
    this.getKeyboardState()
  },
  watch: {
    htmlContent: {
      handler() {
        this.htmlContentCount=this.editor.getContentLength(true)
        // this.htmlContentCount = 0;
        // let htmlState = false; //判断i此时是否在标签中
        // let specialState = false; //判断此时i是否在文本输入的< > & 这些特殊字符中
        // for (let i = 0; i < newVal.length; i++) {
        //   if (newVal.charAt(i) === "<") {
        //     htmlState = true;
        //   } else if (newVal.charAt(i) === ">") {
        //     htmlState = false;
        //   } else if (
        //       newVal.charAt(i) != " " &&
        //       !htmlState &&
        //       newVal.charAt(i) != "&" &&
        //       !specialState
        //   ) {
        //     this.htmlContentCount++;
        //   } else if (newVal.charAt(i) === "&") {
        //     specialState = true;
        //   } else if (newVal.charAt(i) === ";" && specialState) {
        //     specialState = false;
        //     this.htmlContentCount++;
        //   }
        // }
      },
    },
  },
  destroyed() {
    this.monitorKeyboard.onEnd();
    const editor = this.editor;
    editor.destroy(); // 组件销毁时，及时销毁编辑器
    // if (this.toolbarConfig) {
    //   this.toolbarConfig = "";
    // }
  },
  computed: {
    textFn(item) {
      return (item) => {
        if (item.inputLimits == 1) {
          var pattern = new RegExp("[\u4E00-\u9FA5]+");
          if (!pattern.test(item.content)) {
            return "只能输入中文";
          }
        }
        if (item.inputLimits == 2) {
          var pattern = new RegExp("[A-Za-z]+");
          if (!pattern.test(item.content)) {
            return "只能输入英文";
          }
        }
        if (item.inputLimits == 3) {
          var pattern = new RegExp("[0-9]+");
          if (!pattern.test(item.content)) {
            return "只能输入数字";
          }
        }
        if (item.inputLimits == 4) {
          var pattern = new RegExp(
              "^(0|86|17951)?(13[0-9]|15[012356789]|17[678]|18[0-9]|14[57])[0-9]{8}$"
          );
          if (!pattern.test(item.content)) {
            return "输入正确手机号";
          }
        }
        if (item.inputLimits == 5) {
          var pattern = new RegExp(
              "^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+"
          );
          if (!pattern.test(item.content)) {
            return "输入正确邮箱";
          }
        }
        return false;
      };
    },
  },
  methods: {
    openTempModal(){
      this.templateShow = true;
    },
    insertTemp(obj){
      this.htmlContent = obj.code;
      this.title = obj.title;
      this.templateShow = false;
    },
    radioChange(val){
      if(val===2){
        this.noFirst = true;
      }
      if(!this.coverImg&&val === 1){
        message.error("请在稿件发文设置中添加展示封面后再选择");
        if(this.noFirst) {
          this.weiForm.imgType = 2;
        }else{
          this.weiForm.imgType = ""
        }
      }
    },
    getKeyboardState(){
      let _this = this;
      this.monitorKeyboard = new MonitorKeyboard();
      this.monitorKeyboard.onStart();

      // 监听虚拟键盘弹出事件
      this.monitorKeyboard.onShow(() => {  
         _this.btnShow = false;
      })

      //监听键盘收起的事件
      this.monitorKeyboard.onHidden(() => {
         _this.btnShow = true;
      })
    },
    ueditorReady(editor) {
      this.editor = editor;
      // editor.placeholder('<span style="color:#999">正文</span>')
      // this.editor.setContent(this.txtUpdate);
      let _this = this;
      this.editor.addListener("fullscreenchanged", function(t, enabled) {
        if(!enabled){
          editor.unsetFloating();
        }
      });
      //  this.editor.addListener("focus", function(t, enabled) {
      //   if(enabled){
      //      _this.btnShow = false;
      //   }
      // });
      //  this.editor.addListener("blur", function(t, enabled) {
      //   if(enabled){
      //      _this.btnShow = true;
      //   }
      // });
    },

    editTxt() {
      this.isEdit = true;
      this.$el.querySelector(`#faWenSet`).scrollIntoView({
        behavior: "smooth",  // 平滑过渡
        block: "start"  // 上边框与视窗顶部平齐。默认值
      });
    },
    editTxtTwo() {
      this.isEdit = false;
      this.$el.querySelector(`#zaiYao`).scrollIntoView({
        behavior: "smooth",  // 平滑过渡
        block: "start"  // 上边框与视窗顶部平齐。默认值
      });
    },
    replaceResults() {
      importUrlToHtml({
        url: this.linkTxtForm.linkTxt,
        proportion: 0.5,
      }).then((res) => {
        if (res.code == 0) {
          this.editorData = res.data.html;
          if (this.editor) {
            this.$nextTick(() => {
              // this.editor.select([]);
              // this.editor.deleteFragment();
              console.log(document.getElementById("editerHtml"), 'xxxxxxxxxx');
              this.editor.setContent(document.getElementById("editerHtml").innerHTML);
              this.linkImportShow = false;
            });
          }
        }
      })
    },
    removeLink(item) {
      this.$nextTick(() => {
        this.editor.setContent(item);
        this.darkLinkShow = false;
      })
    },
    handleCloseColum() {
      this.linkImportShow = false;
    },
    newMedia(newSelectData) {
      this.newSelectData = newSelectData;
      console.log(this.newSelectData, 'xxx')
    },
    newMediaWeiBo(newSelectData) {
      this.sinaWeiBoData = newSelectData;
    },
    selectWeiXin() {
      this.isShowWei = true;
    },
    selectWeiBo() {
      this.isShowWeiBo = true;
    },
    selectCloseWei() {
      this.isShowWei = false;
    },
    selectCloseWeiBo() {
      this.isShowWeiBo = false;
    },
    customInsert(res, insertFn) {
      this.loadingBox = true;
      if (res.code != 0) {
        message.error(res.msg);
        return;
      }
      let url = this.imgIp + res.data.path;
      let alt = res.data.name;
      insertFn(url, alt, "");
      this.loadingBox = false;
    },
    toBack() {
      // this.$router.push({
      //   path: "/index/content/all_manuscripts",
      //   query: {
      //     type: this.$route.query.type,
      //   },
      // });
      //window.history.go(-1);
      window.close();
    },
    imgList(data, index, columnIndex, column, type) {
      this.beforeUpload(data.file, index, columnIndex, column, type);
    },
    // onCreated(editor) {
    //   let a = (this.editor = Object.seal(editor)); // 一定要用 Object.seal() ，否则会报错
    //   editor.insertText("xxx");
    // },
    identifyKeywords() {
    },
    beforeUploadNewWei(file) {
      // 验证大小
      if (file.size > 20 * 1024 * 1024) {
        message.error('只能上传20MB以内的图片')
        return;
      }
      const isJpgOrPng = file.type === "image/jpg" || file.type === "image/png";
      if (!isJpgOrPng) {
        message.error('只能上传jpg和png格式图片')
        return;
      }
      let formData = new FormData();
      formData.append("file", file);
      formData.append("type", 'wei_xin');
      uploadImg(file, 'site_setting').then((res) => {
        this.weiForm.imgUrl = res.path;
      })
      return false;

    },

    beforeUploadWeiBo(file) {
      // 验证大小
      if (file.size > 20 * 1024 * 1024) {
        message.error('只能上传20MB以内的图片')
        return;
      }
      const isJpgOrPng = file.type === "image/jpg" || file.type === "image/png";
      if (!isJpgOrPng) {
        message.error('只能上传jpg和png格式图片')
        return;
      }
      let formData = new FormData();
      formData.append("file", file);
      formData.append("type", 'wei_xin');
      uploadImg(file, 'site_setting').then((res) => {
        this.weiBoForm.imgUrl = res.path;
      })
      return false;

    },
    beforeUpload(file, index, columnIndex, column, type, fileList = []) {
      const _this = this;
      // 文件验证 大小验证
      console.log(file, 'sss', column)
      if (column.fileSize != 0) {
        if (column.dataType == 0) {
          if (file.size > column.fileSize * 1024) {
            message.error("文档大小不能超过" + column.fileSize + "kb");
            return;
          }
        } else {
          if (file.size > column.fileSize * 1024 * 1024) {
            message.error("文档大小不能超过" + column.fileSize + "MB");
            return;
          }
        }
      }
      // 验证 文件格式
      if (type == 1 || type == 0) {
        let indexFile = file.type.lastIndexOf("/");
        let str = file.type.substring(indexFile + 1, file.type.length);
        console.log(column.uploadType.split(','), file, 'ss')
        if (column.uploadType.split(',').indexOf(str) == -1) {
          message.error('只能上传格式为' + column.uploadType + '的文件')
          return;
        }
      } else {
        let indexFile = file.name.lastIndexOf(".");
        let str = file.name.substring(indexFile + 1, file.name.length);
        if (column.uploadType.split(',').indexOf(str) == -1) {
          message.error('只能上传格式为' + column.uploadType + '的文件')
          return;
        }
      }

      // 文件数量
      switch (type) {
        case 1:
          var array = [];
          if (_this.moreImgUrlList[column.id + column.type] && _this.moreImgUrlList[column.id + column.type].length > 0) {
            array = [
              ..._this.moreImgUrlList[column.id + column.type],
              ...fileList,
            ];
          } else {
            array = [...fileList];
          }
          if (array.length > column.number) {
            message.error("最多只能上传" + column.number + "文件");
            return;
          }
          break;
        // case 2:
        //   var array = [];
        //   if (_this.vidioList[column.id + column.type] && _this.vidioList[column.id + column.type].length > 0) {
        //     array = [..._this.vidioList[column.id + column.type], ...fileList];
        //   } else {
        //     array = [...fileList];
        //   }
        //   if (array.length > column.number) {
        //     message.error("最多只能上传" + column.number + "文件");
        //     return;
        //   }
        //   break;
        // case 3:
        //   var array = [];
        //   if (_this.mp3List[column.id + column.type] && _this.mp3List[column.id + column.type].length > 0) {
        //     array = [..._this.mp3List[column.id + column.type], ...fileList];
        //   } else {
        //     array = [...fileList];
        //   }
        //   if (array.length > column.number) {
        //     message.error("最多只能上传" + column.number + "文件");
        //     return;
        //   }
        //   break;
        // case 4:
        //   var array = [];
        //   if (_this.fileList[column.id + column.type] && _this.fileList[column.id + column.type].length > 0) {
        //     array = [..._this.fileList[column.id + column.type], ...fileList];
        //   } else {
        //     array = [...fileList];
        //   }
        //   if (array.length > column.number) {
        //     message.error("最多只能上传" + column.number + "文件");
        //     return;
        //   }
        //   break;
      }

      let formData = new FormData();
      formData.append("type", type);
      formData.append("uploadType", column.uploadType);
      formData.append("fileSize", column.fileSize);
      formData.append("dataType", column.dataType);
      formData.append("number", column.dataType);
      formData.append("files", file);
      uploadFile(formData).then((res) => {
        if (res.code == 0) {
          if (res.data.error.length > 0) {
            message.error(res.data.error[0].msg);
            return;
          }
          var encodedData = window.btoa(
              process.env.VUE_APP_Img_Ip + res.data.correct[0].path
          ); // 编码
          let url =
              `${process.env.VUE_APP_Preview}?url=` + encodedData;
          file.url = url;
          switch (type) {
            case 0:
              _this.imgUrlList[index] = {};
              _this.imgUrlList[index][columnIndex + "url"] = [res.data.correct[0]]
              _this.imgUrlList = JSON.parse(JSON.stringify(_this.imgUrlList));
              break;
            case 1:
              if (!_this.fileListTwo[column.id + column.type]) {
                _this.fileListTwo[column.id + column.type] = [];
              }
              if (!_this.moreImgUrlList[column.id + column.type]) {
                _this.moreImgUrlList[column.id + column.type] = [];
              }
              _this.fileListTwo[column.id + column.type].push(
                  res.data.correct[0]
              );
              _this.moreImgUrlList[column.id + column.type].push(file);
              _this.fileListTwo = JSON.parse(JSON.stringify(_this.fileListTwo));
              break;
            case 2:
              if (!_this.fileListTwoVideo[column.id + column.type]) {
                _this.fileListTwoVideo[column.id + column.type] = []
              }
              _this.fileListTwoVideo[column.id + column.type].push(
                  res.data.correct[0]
              );
              if (!_this.vidioList[column.id + column.type]) {
                _this.vidioList[column.id + column.type] = [];
              }
              _this.vidioList[column.id + column.type].push(file);
              _this.fileListTwoVideo = JSON.parse(
                  JSON.stringify(_this.fileListTwoVideo)
              );
              break;
            case 3:
              if (!_this.fileListTwoMp3[column.id + column.type]) {
                _this.fileListTwoMp3[column.id + column.type] = [];
              }
              _this.fileListTwoMp3[column.id + column.type].push(
                  res.data.correct[0]
              );
              if (!_this.mp3List[column.id + column.type]) {
                _this.mp3List[column.id + column.type] = [];
              }
              _this.mp3List[column.id + column.type].push(file);
              _this.fileListTwoMp3 = JSON.parse(
                  JSON.stringify(_this.fileListTwoMp3)
              );
              break;
            case 4:
              if (!_this.fileListTwoFile[column.id + column.type]) {
                _this.fileListTwoFile[column.id + column.type] = [];
              }
              if (!_this.fileList[column.id + column.type]) {
                _this.fileList[column.id + column.type] = [];
              }
              _this.fileListTwoFile[column.id + column.type].push(
                  res.data.correct[0]
              );
              _this.fileList[column.id + column.type].push(file);
              _this.fileListTwoFile = JSON.parse(
                  JSON.stringify(_this.fileListTwoFile)
              );
              break;
          }
        }
      });
      //console.log(res,'shang')

      return false;
    },
    linkImport() {
      this.linkImportShow = true;
    },
    handleChange() {
    },
    handleClick() {
    },
    //根据栏目id查询模型参数
    getModelByColumn(columnIds, arr) {
      const _this = this;
      selectModelByColumnId({idList: columnIds}).then((res) => {
        if (res.code == 0) {
          let modelColumns = res.data;
          let modelId = [];
          for (let i = 0; i < modelColumns.length; i++) {
            if (
                modelColumns[i].fieldResponse.dateCreateRequest &&
                modelColumns[i].fieldResponse.dateCreateRequest.length
            ) {
              modelColumns[i].fieldResponse.dateCreateRequest.map((column) => {
                if (column.defaultDate) {
                  column.content = "";
                } else {
                  column.content = new Date();
                }
                if (arr && arr.length > 0 && arr[`${column.id}${column.type}`]) {
                  column.content = arr[`${column.id}${column.type}`].content || '';
                }
                column.fieldId = column.id;
              });
            }
            if (
                modelColumns[i].fieldResponse.fieldTextCreateRequests &&
                modelColumns[i].fieldResponse.fieldTextCreateRequests.length
            ) {
              modelColumns[i].fieldResponse.fieldTextCreateRequests.map((column) => {
                // column.content=""
                if (arr && arr.length > 0 && arr[`${column.id}${column.type}`]) {
                  column.content = arr[`${column.id}${column.type}`].content || '';
                }
                column.fieldId = column.id;
              });
            }
            if (
                modelColumns[i].fieldResponse.fieldOptionCreateRequests &&
                modelColumns[i].fieldResponse.fieldOptionCreateRequests.length
            ) {
              modelColumns[i].fieldResponse.fieldOptionCreateRequests.map((column) => {
                column.fieldId = column.id;
                if (column.type == 0) {
                  column.content = "";
                } else if (column.type == 1) {
                  column.content = [];
                } else if (column.type == 2) {
                  column.content = "";
                }
                if (arr && arr.length > 0 && arr[`${column.id}${column.type}`]) {
                  column.content = arr[`${column.id}${column.type}`].content || '';
                }
              });
            }
            // 文件上传
            if (
                modelColumns[i].fieldResponse.fieldFileCreateRequests &&
                modelColumns[i].fieldResponse.fieldFileCreateRequests.length
            ) {
              modelColumns[i].fieldResponse.fieldFileCreateRequests.map((column) => {
                if (column.type == 1) {
                  if (!this.fileListTwo[column.id + column.type]) {
                    this.fileListTwo[column.id + column.type] = [];
                  }
                  if (!this.moreImgUrlList[column.id + column.type]) {
                    this.moreImgUrlList[column.id + column.type] = [];
                  }
                }
                if (column.type == 2) {
                  if (!this.fileListTwoVideo[column.id + column.type]) {
                    this.fileListTwoVideo[column.id + column.type] = [];
                  }

                  if (!this.vidioList[column.id + column.type]) {
                    this.vidioList[column.id + column.type] = [];
                  }
                }
                if (column.type == 3) {
                  if (!this.fileListTwoMp3[column.id + column.type]) {
                    this.fileListTwoMp3[column.id + column.type] = [];
                  }
                  if (!this.mp3List[column.id + column.type]) {
                    this.mp3List[column.id + column.type] = [];
                  }
                }
                if (column.type == 4) {
                  if (!this.fileListTwoFile[column.id + column.type]) {
                    this.fileListTwoFile[column.id + column.type] = [];
                  }
                  if (!this.fileList[column.id + column.type]) {
                    this.fileList[column.id + column.type] = [];
                  }
                }
              });
            }
            if (modelColumns[i].fieldResponse.indexRequests && modelColumns[i].fieldResponse.indexRequests.length > 0) {
              modelColumns[i].fieldResponse.indexRequests.map((column) => {
                if (arr && arr.length > 0 && arr[`${column.id}${column.type}`]) {
                  column.content = arr[`${column.id}${column.type}`].content || '';
                } else {
                  column.content = ''
                }
                if (!column.content) {
                  getIndexNumber({
                    id: sessionStorage.getItem('siteId'),
                  }).then((res) => {
                    if (res.code == 0) {
                      column.content = `${res.data.indexNumber}`;
                    }
                  })
                }
                column.fieldId = column.id;
              })
            }
            modelId.push(modelColumns[i].id);
          }
          _this.ModelColumns = modelColumns;
          _this.modelId = modelId.toString();
          _this.isLodaing = true;
        }
      });
    },
    openChooseCover() {
      this.resourceIsShow = true;
    },
    colseChooseCover() {
      this.resourceIsShow = false;
    },
    openChooseColumn() {
      this.isColumn = true;
      this.$nextTick(() => {
        this.$refs.chooseColumn.getColumnTree();
      })
    },
    setColumnIds(data) {
      this.columnIds = data.columnIds;
      this.columnData = data.columnData;
      console.log(data, 'ssssssss')
      this.isColumn = false;
      let oldData = JSON.parse(JSON.stringify(this.ModelColumns));
      let arr = [];
      if (oldData.length > 0) {
        oldData.forEach((element) => {
          element.fieldResponse.fieldTextCreateRequests &&
          element.fieldResponse.fieldTextCreateRequests.forEach((item) => {
            arr[`${item.id}${item.type}`] = item;
          });
          element.fieldResponse.fieldOptionCreateRequests &&
          element.fieldResponse.fieldOptionCreateRequests.forEach((item) => {
            arr[`${item.id}${item.type}`] = item;
          });
          element.fieldResponse.fieldFileCreateRequests &&
          element.fieldResponse.fieldFileCreateRequests.forEach((item) => {
            arr[`${item.id}${item.type}`] = item;
          });
          element.fieldResponse.dateCreateRequest &&
          element.fieldResponse.dateCreateRequest.forEach((item) => {
            arr[`${item.id}${item.type}`] = item;
          });
        });
      }
      this.getModelByColumn(this.columnIds, arr);
    },
    colseChooseLink() {
      this.isLink = false;
    },
    openChooseLink() {
      this.isLink = true;
      this.$nextTick(()=>{
         this.$refs.chooseLink.getColumnTree();
         this.$refs.chooseLink.setLinkInfoList({
          customLinkList: [],
          LinkInfo: this.LinkInfo,
        });
      })
      //this.$refs.chooseLink.getLinksPage();
    },
    weiXinDel(index) {
      this.newSelectData.splice(index, 1)
    },
    weiBoDel(index) {
      this.sinaWeiBoData.splice(index, 1)
    },
    openLink() {
      this.isLink = true;
    },
    setLinkIds(data) {
      this.LinkIds = data.LinkIds;
      this.LinkInfo = data.LinkInfo;
      this.isLink = false;
    },
    filterHtml(str){
      let doc = new DOMParser().parseFromString(str,"text/html");
      let flag = false;
      if(doc.getElementsByClassName("tipsImg").length>0) flag = true;
      if(flag){
        let arrs = doc.getElementsByClassName("tipsImg");
        //删除提示图片；
        while (arrs.length) {
          arrs[0].remove();
          arrs = doc.getElementsByClassName("tipsImg");
        }
        this.title = this.title.replace("（单位名称）","");
        //获取指定表格，验证每列关系是否成立；
        for(let j = 0;j<6;j++){
          let relations = doc.getElementsByClassName("relation"+j);
          if(Number(relations[0].innerText)+Number(relations[1].innerText) !== Number(relations[2].innerText)+Number(relations[3].innerText)&&flag){
            message.error("政府信息公开申请情况表中勾稽关系不正确，请核对后提交");
            flag = false;
          }
        }
      }else{
        flag = true;
      }
      if(flag){
        this.htmlContent = doc.body.innerHTML;
      }
      return flag;
    },
    //稿件数据保存
    saveManuscript(cType) {
      if(!this.source){
        message.error("请填写文章来源");
        return;
      }
      if(!this.keyword){
        message.error("请填写关键词或识别关键词");
        return;
      }
      let result = this.filterHtml(this.htmlContent);
      if(!result) return;

      //this.editor.focus(true)  
      setTimeout(()=>{
      const _this = this;
      let errorData = document.getElementsByClassName("item-error");
      if (errorData.length > 0) {
        message.error("请正确填写数据");
        return;
      }

      if (cType == 2 || cType == 4) {
        if(cType == 2){
          if(_this.columnIds.length == 0){
                message.error("至少选择一个发布栏目");
                return;
            }
        }
        if (!this.detected) {
          this.isDetected = true
          return
        }
        if (cType == 2) {
          this.loadingTwo = true;
        }
        if (cType == 4) {
          this.loadingFour = true;
        }

      } else if (cType == 3) {
        this.loadingThree = true;
      } else {
        this.loading = true;
      }
      let siteId = sessionStorage.getItem("siteId");
      let TextRequests = [];
      let takeModelColumns = JSON.parse(JSON.stringify(_this.ModelColumns));
      takeModelColumns.forEach((item, index) => {
        if (
            item.fieldResponse.fieldFileCreateRequests &&
            item.fieldResponse.fieldFileCreateRequests.length
        ) {
          item.fieldResponse.fieldFileCreateRequests.map(
              (column, columnIndex) => {
                column.fieldId = column.id;
                column.modelId = item.id;
                column.id = null;
                switch (column.type) {
                  case 0:
                    column.content = _this.imgUrlList[index]
                        ? JSON.stringify(_this.imgUrlList[index][columnIndex + "url"])
                        : "";
                    column.type = 6;
                    break;
                  case 1:
                    column.content = _this.fileListTwo[
                    column.fieldId + column.type
                        ] && _this.fileListTwo[
                    column.fieldId + column.type
                        ].length > 0
                        ? JSON.stringify(_this.fileListTwo[column.fieldId + column.type])
                        : "";
                    column.type = 7;
                    break;
                  case 2:
                    column.content = _this.fileListTwoVideo[
                    column.fieldId + column.type
                        ] && _this.fileListTwoVideo[
                    column.fieldId + column.type
                        ].length > 0
                        ? JSON.stringify(_this.vidioList[column.fieldId + column.type])
                        : "";
                    column.type = 8;
                    break;
                  case 3:
                    column.content = _this.fileListTwoMp3[
                    column.fieldId + column.type
                        ] && _this.fileListTwoMp3[
                    column.fieldId + column.type
                        ].length > 0
                        ? JSON.stringify(_this.fileListTwoMp3[column.fieldId + column.type])
                        : "";
                    column.type = 9;
                    break;
                  case 4:
                    column.content = _this.fileListTwoFile[
                    column.fieldId + column.type
                        ] && _this.fileListTwoFile[
                    column.fieldId + column.type
                        ].length > 0
                        ? JSON.stringify(_this.fileListTwoFile[column.fieldId + column.type])
                        : "";
                    column.type = 10;
                    break;
                }
              }
          );
        }
        if (
            item.fieldResponse.dateCreateRequest &&
            item.fieldResponse.dateCreateRequest.length
        ) {
          item.fieldResponse.dateCreateRequest.map((column) => {
            column.type = 2;
            column.modelId = item.id;
            column.id = null;
            column.content = _this.farmatDate(column.content, "-");
          });
        }
        // 索引号
        if (
            item.fieldResponse.indexRequests &&
            item.fieldResponse.indexRequests.length
        ) {
          item.fieldResponse.indexRequests.map((column) => {
            column.type = 11;
            column.modelId = item.id;
            column.id = null;
          });
        }

        if (
            item.fieldResponse.fieldTextCreateRequests &&
            item.fieldResponse.fieldTextCreateRequests.length
        ) {
          item.fieldResponse.fieldTextCreateRequests.map((column) => {
            column.modelId = item.id;
            column.type = column.type == 0 ? 0 : 1;
            column.id = null;
          });
        }
        if (
            item.fieldResponse.fieldOptionCreateRequests &&
            item.fieldResponse.fieldOptionCreateRequests.length
        ) {
          item.fieldResponse.fieldOptionCreateRequests.map((column) => {
            column.modelId = item.id;
            column.type == 1
                ? (column.content = column.content.join(","))
                : (column.content = column.content);
            column.type = column.type == 0 ? 3 : column.type == 1 ? 4 : 5;
            column.id = null;
          });
        }
        item.fieldResponse.fieldFileCreateRequests
            ? TextRequests.push(...item.fieldResponse.fieldFileCreateRequests)
            : "";
        item.fieldResponse.fieldOptionCreateRequests
            ? TextRequests.push(...item.fieldResponse.fieldOptionCreateRequests)
            : "";
        item.fieldResponse.fieldTextCreateRequests
            ? TextRequests.push(...item.fieldResponse.fieldTextCreateRequests)
            : "";
        item.fieldResponse.dateCreateRequest
            ? TextRequests.push(...item.fieldResponse.dateCreateRequest)
            : "";
        item.fieldResponse.indexRequests
            ? TextRequests.push(...item.fieldResponse.indexRequests)
            : "";
      });
      _this.LinkInfo.map((item) => {
        if (!item.type) {
          item.maId = item.id;
          item.id = null;
          item.type = 0;
        }
      });
      let mediaConfigRequest = []
      let weiMediaData = [];
      let weiBoMedaData = [];
      let weiData = {...this.weiForm, mediaData: ''};
      let weiBo = {...this.weiBoForm, mediaData: ''}
      if (this.newSelectData.length > 0) {
        for (let index = 0; index < this.newSelectData.length; index++) {
          weiMediaData.push({
            id: this.newSelectData[index].id,
            name: this.newSelectData[index].nickName,
            type: 1,
          })
        }
        weiData.mediaData = JSON.stringify(weiMediaData)
      }
      if (this.sinaWeiBoData.length > 0) {
        for (let index = 0; index < this.sinaWeiBoData.length; index++) {
          weiBoMedaData.push({
            id: this.sinaWeiBoData[index].id,
            name: this.sinaWeiBoData[index].screenName,
            type: 2,
          })
        }
        weiBo.mediaData = JSON.stringify(weiBoMedaData)
      }
      mediaConfigRequest.push(weiData)
      mediaConfigRequest.push(weiBo)
      let reqData = {
        title: _this.title,
        siteId: siteId,
        time: _this.farmatDate(_this.createTime, "-"),
        source: _this.source,
        abstractText: _this.abstractText,
        content: _this.htmlContent,
        columnId: _this.columnIds.join(","),
        modelId: _this.modelId,
        coverImg: _this.coverImg,
        linksRequests: _this.LinkInfo,
        keyword: _this.keyword,
        redirectUrl: _this.redirectUrl,
        detailsTextRequests: TextRequests,
        mediaConfigRequest,
      };
      if (cType == 1) {
        //草稿
        createDraft(reqData).then((res) => {
          if (res.code == 0) {
            if(!res.data){
               message.success(res.msg);
              setTimeout(() => {
                this.toBack();
              }, 2000);
            }else{
              if(res.data.mark){
                  for (let index = 0; index < _this.ModelColumns.length; index++) {
                    const element = _this.ModelColumns[index];
                    if (
                        element.fieldResponse.indexRequests &&
                        element.fieldResponse.indexRequests.length
                    ) {
                      element.fieldResponse.indexRequests.map((column) => {
                        column.type = 11;
                        column.modelId = element.id;
                        column.content = res.data.indexNumber;
                        column.id = null;
                      });
                    }
                }
                message.error('索引号已经被占用系统已为你重新生成请在提交一次');
             }
            }
          }
          this.loading = false;
          this.loadingTwo = false;
          this.loadingFour = false
          this.loadingThree = false;
        });
      } else if (cType == 2) {
        createManuscript(reqData).then((res) => {
          if (res.code == 0) {
            // 索引号重复
            if(!res.data){
               message.success(res.msg);
              setTimeout(() => {
                this.toBack();
              }, 2000);
            }else{
              if(res.data.mark){
                  for (let index = 0; index < _this.ModelColumns.length; index++) {
                    const element = _this.ModelColumns[index];
                    if (
                        element.fieldResponse.indexRequests &&
                        element.fieldResponse.indexRequests.length
                    ) {
                      element.fieldResponse.indexRequests.map((column) => {
                        column.type = 11;
                        column.modelId = element.id;
                        column.content = res.data.indexNumber;
                        column.id = null;
                      });
                    }
                }
                message.error('索引号已经被占用系统已为你重新生成请在提交一次');
             }
            }
        }
          this.loading = false;
          this.loadingTwo = false;
          this.loadingFour = false
          this.loadingThree = false;
        });
      } else if (cType == 3) {
        if (!reqData.columnId) {
          message.error('请选择栏目');
          this.loading = false;
          this.loadingTwo = false;
          this.loadingFour = false
          this.loadingThree = false;
          return;
        }
        previewManuscript(reqData).then((res) => {
          window.open('http://' + res.data.previewUrl);
          this.loading = false;
          this.loadingTwo = false;
          this.loadingFour = false
          this.loadingThree = false;
        });
      } else if (cType == 4) {
        createManuscript(reqData).then((res) => {
          if (res.code == 0) {
            if(res.data && res.data.mark){
                  for (let index = 0; index < _this.ModelColumns.length; index++) {
                    const element = _this.ModelColumns[index];
                    if (
                        element.fieldResponse.indexRequests &&
                        element.fieldResponse.indexRequests.length
                    ) {
                      element.fieldResponse.indexRequests.map((column) => {
                        column.type = 11;
                        column.modelId = element.id;
                        column.content = res.data.indexNumber;
                        column.id = null;
                      });
                    }
                }
                message.error('索引号已经被占用系统已为你重新生成请在提交一次');
                this.loading = false;
                this.loadingTwo = false;
                this.loadingFour = false
                this.loadingThree = false;
                return;
             }else{
               message.success(res.msg);
             }
            this.title = '';
            this.source = '';
            this.abstractText = '';
            this.htmlContent = '';
            this.coverImg = '';
            this.LinkInfo = [];
            this.LinkIds = [];
            this.keyword = '';
            this.redirectUrl = '';
            this.sinaWeiBoData = [];
            this.newSelectData = [];
            this.createTime = new Date();
            this.weiForm = {
              type: 1,
              title: '',
              links: '',
              imgUrl: '',
              imgType: '',
            },
                this.weiBoForm = {
                  type: 2,
                  title: '',
                  links: '',
                  imgUrl: '',
                  imgType: '',
                }
                this.imgUrlList = []; //单图路径
                this.moreImgUrlList = []; //多图上传路径
                this.vidioList = []; //视频文件路劲
                this.mp3List = []; //音频文件路径
                this.fileList = []; //文件路径
                if(this.columnIds.length > 0){
                  this.getModelByColumn(this.columnIds);
                }
          }
          this.loading = false;
          this.loadingTwo = false;
          this.loadingFour = false
          this.loadingThree = false;
        });
      }
      },200);
    },
    changeTime(data) {
      this.ModelColumns = JSON.parse(JSON.stringify(this.ModelColumns));
    },
    errorFn(item, index) {
    },
    removeImg(file, itemId, columnId, column, type) {
      const index = this.moreImgUrlList[column.id + column.type].indexOf(file);
      this.moreImgUrlList[column.id + column.type].splice(index, 1);
      this.fileListTwo[column.id + column.type].splice(index, 1);
    },
    removeVideo(file, itemId, columnId, column, type) {
      const index = this.vidioList[column.id + column.type].indexOf(file);
      this.vidioList[column.id + column.type].splice(index, 1);
      this.fileListTwoVideo[column.id + column.type].splice(index, 1);
    },
    removeMp3(file, itemId, columnId, column, type) {
      const index = this.mp3List[column.id + column.type].indexOf(file);
      this.mp3List[column.id + column.type].splice(index, 1);
      this.fileListTwoMp3[column.id + column.type].splice(index, 1);
    },
    removeFile(file, itemId, columnId, column, type) {
      const index = this.fileList[column.id + column.type].indexOf(file);
      this.fileList[column.id + column.type].splice(index, 1);
      this.fileListTwoFile[column.id + column.type].splice(index, 1);
    },
    farmatDate(date, cut) {
      var date = new Date(date);
      var YY = date.getFullYear() + cut;
      var MM =
          (date.getMonth() + 1 < 10
              ? "0" + (date.getMonth() + 1)
              : date.getMonth() + 1) + cut;
      var DD = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      var hh =
          (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) + ":";
      var mm =
          (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) +
          ":";
      var ss =
          date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      return YY + MM + DD + " " + hh + mm + ss;
    },
    setCoverImg(imgUrl) {
      this.coverImg = imgUrl;
    },
    colseChooseColumn() {
      this.isColumn = false;
    },
    deleteFn(index, key) {
      this.columnIds.splice(this.columnIds.indexOf(key), 1);
      this.columnData.splice(index, 1);
      this.$nextTick(() => {
        this.$refs.chooseColumn.deleteResult(index);
      })
      if (this.columnIds.length > 0) {
        this.getModelByColumn(this.columnIds);
      } else {
        this.ModelColumns = [];
      }
    },
    deleteLinks(index) {
      if (this.LinkInfo[index].type != 1) {
        this.LinkIds.splice(index, 1);
        this.$nextTick(() => {
          this.$refs.chooseLink.deleteFn(index);
        });
      } else {
        this.$refs.chooseLink.deleteCustomLink2(this.LinkInfo[index]);
      }
      this.LinkInfo.splice(index, 1);
    },
    //编辑替换图片
    toEditImg() {
      this.resourceIsShow = true;
      this.$refs.chooseCover.toEditImg(this.coverImg);
    },
    deleteImg() {
      this.coverImg = "";
      this.$refs.chooseCover.deleteImg();
    },
    //打开错敏检测页面
    // openMisse() {
    //   this.detected = true
    //   this.misseIsShow = true;
    // },
    // closeMisse() {
    //   this.misseIsShow = false;
    // },
    //打开暗链检测页面
    openDarkLink() {
      this.editorHtml = this.editor.getContent();
      this.darkLinkShow = true;
    },
    closeDarkLink() {
      this.darkLinkShow = false;
    },
    beforeUploadFile(file) {
      let suffix = file.name.substring(file.name.lastIndexOf(".") + 1);
      suffix = suffix.toLowerCase();
      if (this.importType == 1) {
        if (suffix != "doc" && suffix != "docx") {
          message.error("只能上传doc或者docx文件");
          return;
        }
      }
      if (this.importType == 2) {
        if (suffix != "xlsx"&&suffix != "xls") {
          message.error("只能上传xlsx或者xls文件");
          return;
        }
      }
      if (this.importType == 3) {
        if (suffix != "pdf") {
          message.error("只能上传pdf文件");
          return;
        }
      }
      if (this.importType == 4) {
        if (suffix != "pptx"&&suffix != "ppt") {
          message.error("只能上传pptx或者ppt文件");
          return;
        }
      }
      this.importFile = file;
      this.fileListExple = [file];
      return false;
    },
    openImport(type) {
      this.importType = type;
      this.importIsShow = true;
      this.fileListExple = [];
    },
    closeImport() {
      this.importIsShow = false;
    },
    changeType(type) {
      this.tabsType = type;
    },
    getDefaultStyle(dd, attribute) {
      // 返回最终样式函数，兼容 IE 和 DOM，设置参数：元素对象、样式特性

      return dd.currentStyle
          ? dd.currentStyle[attribute]
          : document.defaultView.getComputedStyle(dd, false)[attribute];
    },
    //word导入
    importWord() {
      const _this = this;
      let formData = new FormData();
      formData.append("file", _this.importFile);
      this.loadServe=Loading.service({fullscreen:true});
      switch (_this.importType) {
        case 1:
          importWordToHtml(formData).then((res) => {
            this.$nextTick(() => { // 以服务的方式调用的 Loading 需要异步关闭
              this.loadServe.close();
            });
            if (res.code == 0) {
              // this.editor.select([]);
              // this.editor.deleteFragment();
              let resData = juice(res.data.html);
              this.editorData = resData;
              if (res.data.format == "docx") {
                this.$nextTick(() => {
                  let fter = document
                      .getElementById("editerHtml")
                      .getElementsByTagName("p");
                  for (const item in fter) {
                    let one = fter[item].children;
                    if (one && one.length > 0) {
                      for (const iteratorOne of one) {
                        for (const iterator of iteratorOne.style) {
                          if (iterator == "font-weight") {
                            iteratorOne.innerHTML = `<b>${iteratorOne.textContent}</b>`;
                          }
                        }
                      }
                    }
                  }
                  this.editor.setContent(
                      document.getElementById("editerHtml").innerHTML
                  );
                });
              } else {
                this.$nextTick(() => {
                  let fter = document
                      .getElementById("editerHtml")
                      .getElementsByTagName("p");
                  for (const item in fter) {
                    let one = fter[item].children;
                    if (one && one.length > 0) {
                      for (const iterator of one[0].style) {
                        let fontSize = this.getDefaultStyle(
                            one[0].parentNode,
                            "font-size"
                        );
                        let fontFamily = this.getDefaultStyle(
                            one[0].parentNode,
                            "font-family"
                        );
                        one[0].style.fontSize = `${fontSize}`;
                        one[0].style.fontFamily = `${fontFamily}`;
                        if (iterator == "font-weight") {
                          one[0].innerHTML = `<b>${one[0].textContent}</b>`;
                        }
                      }
                    }
                  }
                  this.editor.setContent(
                      document.getElementById("editerHtml").innerHTML
                  );
                });
              }
              // this.$nextTick(()=>{
              //   let spanS = document.getElementById("editerHtml").getElementsByTagName('p');
              //     for (let index = 0; index < spanS.length; index++) {
              //       let element = spanS[index];
              //       element.innerHTML = element.innerHTML.replaceAll('&nbsp;','')
              //       let childArray = [];
              //       let type = '';
              //       for (let index = 0; index < element.children.length; index++) {
              //         const itemChild =  element.children[index];
              //           if(itemChild.src){
              //                   type = 'image';
              //                   const nodeImg = { 
              //                     type:'paragraph', 
              //                     children: [
              //                       {
              //                         type:'image', 
              //                         src:itemChild.src,
              //                         style:{width:itemChild.style['width'],height:itemChild.style['height']},
              //                         children:[{
              //                            text:'',
              //                         }]
              //                       }
              //                     ],
              //                   }
              //                 this.editor.insertNode(nodeImg);
              //           }else{
              //              type = 'paragraph';
              //               childArray.push(
              //                     { 
              //                       text:itemChild.innerHTML,
              //                       fontSize:itemChild.style['font-size'],
              //                       fontFamily:itemChild.style['font-family'],
              //                       color:itemChild.style['color'],
              //                       textAlign:itemChild.style['text-align'],
              //                       lineHeight:itemChild.style['line-height'],
              //                       bold:itemChild.style['font-weight']?true:false,
              //                       bgColor:itemChild.style['background-color'],
              //                     }
              //               )
              //           }
              //       }
              //       if(type == 'paragraph'){
              //           const node = { 
              //           type: 'paragraph', 
              //           indent:element.style['text-indent'],
              //           textAlign:element.style['text-align'],
              //           children: childArray,
              //         }
              //         this.editor.insertNode(node);
              //       }

              //     }
              // })
              _this.importIsShow = false;
            }
          }).catch(()=> {
          this.$nextTick(() => { // 以服务的方式调用的 Loading 需要异步关闭
            this.loadServe.close();
          });
        });
          break;
        case 2:
          importExcelToHtml(formData).then((res) => {
            this.$nextTick(() => { // 以服务的方式调用的 Loading 需要异步关闭
              this.loadServe.close();
            });
            if (res.code == 0) {
              // this.editor.select([]);
              // this.editor.deleteFragment();
              this.editor.setContent(juice(res.data.html));
              //_this.htmlContent = juice(res.data)
              console.log(_this.htmlContent, "dsadsa");
              _this.importIsShow = false;
            }
          }).catch(()=> {
            this.$nextTick(() => { // 以服务的方式调用的 Loading 需要异步关闭
              this.loadServe.close();
            });
          });
          break;
        case 3:
          importPdfToHtml(formData).then((res) => {
            this.$nextTick(() => { // 以服务的方式调用的 Loading 需要异步关闭
              this.loadServe.close();
            });
            if (res.code == 0) {
              _this.htmlContent = res.data.html;
              _this.importIsShow = false;
            }
          }).catch(()=> {
            this.$nextTick(() => { // 以服务的方式调用的 Loading 需要异步关闭
              this.loadServe.close();
            });
          });
          break;
        case 4:
          importPptToHtml(formData).then((res) => {
            this.$nextTick(() => { // 以服务的方式调用的 Loading 需要异步关闭
              this.loadServe.close();
            });
            if (res.code == 0) {
              _this.htmlContent = res.data.html;
              _this.importIsShow = false;
            }
          }).catch(()=> {
            this.$nextTick(() => { // 以服务的方式调用的 Loading 需要异步关闭
              this.loadServe.close();
            });
          });
          break;
      }
    },
    // customPaste(editor, event, callback) {
    //   // 同步
    //   const rtf = event.clipboardData.getData("text/rtf");
    //   const html = event.clipboardData.getData("text/html"); // 获取粘贴的 html
    //   console.log(html, "dsa");
    //   editor.insertText();
    //
    //   // 异步
    //   setTimeout(() => {
    //     editor.insertText("yy");
    //   }, 1000);
    //
    //   // 阻止默认的粘贴行为
    //   event.preventDefault();
    //   return false;
    //
    //   // 继续执行默认的粘贴行为
    //   // return true
    // },
    //关键词提取
    getKeyWords() {
      let text = "";
      text = this.getSimpleText(this.htmlContent);
      keyWordsExtract({text: text}).then((res) => {
        if (res.code == 0) {
          this.keyword = res.data.keyWords;
        }
      });
    },
    getSimpleText(html) {
      var re1 = new RegExp("<.+?>", "g"); //匹配html标签的正则表达式，"g"是搜索匹配多个符合的内容
      var res = html.replace(re1, ""); //执行替换成空字符
      res.replace(/&nbsp;/g, "");
      return res;
    },
    //打开错敏检测页面
    openMisse() {
      this.detected = true
      this.isDetected = false
      this.misseIsShow = true;
      // this.$nextTick(() => {
      //   this.$refs.missensity.toCorrectionExtract();
      // });
    },
    closeMisse() {
      this.misseIsShow = false;
    },
    saveMisse(html) {
      this.htmlContent = html;
      this.misseIsShow = false;
    },
    remove() {
      this.fileListExple = [];
    },
  },
};
</script>
<style src="@wangeditor/editor/dist/css/style.css"></style>
<style lang="less" scoped>

.top {
  display: flex;
  align-items: center;
  cursor: pointer;
  position: sticky;
  top: 0;
  width: 100%;
  padding-left: 200px;
  background: #fff;
  z-index: 99;

  .back {
    height: 30px;
    width: 30px;
    line-height: 30px;
    background-color: #f5f5f5;
    /* margin: 20px; */
    border-radius: 50%;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    /* padding: 20px; */
    /* padding: 10px 20px; */
    margin: 10px 20px;

    /deep/ .anticon {
      width: 30px;
    }
  }
}

.content {
  width: 100%;
  height: 100%;
  background: #f0f2f5;
  display: flex;
  padding: 10px 20px;
  justify-content: center;
  overflow-y: auto;
  .set-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 12px;

    .line {
      width: 40%;
      height: 2px;
      background: #eeebeb;
    }
  }

  .left {
    .btn-item {
      width: 118px;
      height: 52px;
      line-height: 52px;
      background: #fff;
      margin-right: 10px;
      text-align: center;
      font-size: 14px;
      box-sizing: border-box;
      margin-bottom: 10px;
      cursor: pointer;
    }
  }

  .middle {
    width: 70%;
    background: #fff;
    max-width: 1000px;

    .t-title {
      padding: 20px 62px;

      .title {
        /deep/ .el-input {
          border-bottom: 1px solid #eeebeb;
          padding: 10px 0;
        }

        /deep/ .el-input__inner {
          border: none;
          color: #415058;
          font-size: 21px;
          font-weight: bold;
        }

        /deep/ input::-webkit-input-placeholder {
          color: #909399;
          font-size: 21px;
          font-weight: bold;
        }
      }

      .info {
        display: flex;
        align-items: center;
        padding: 10px 0;
        border-bottom: 1px solid #eeebeb;

        /deep/ .el-input__inner {
          border: none;
        }

        /deep/ input::-webkit-input-placeholder {
          color: #909399;
          font-size: 14px;
        }

        /deep/ .el-date-editor.el-input,
        .el-date-editor.el-input__inner {
          width: 200px;
        }

        /deep/ .el-input {
          width: 70%;
        }
      }

      .abstract {
        padding: 10px 0;
        border-bottom: 1px solid #eeebeb;

        /deep/ input::-webkit-input-placeholder {
          color: #909399;
          font-size: 14px;
        }

        /deep/ .el-input__inner {
          border: none;
        }
      }
    }

    .setup {
      /deep/ input::-webkit-input-placeholder {
        color: #909399;
        font-size: 12px;
      }

      .setup-bt {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 10px 20px;

        .doc-set {
          /deep/ .el-button {
            border: none;
          }
        }

        .icon-edit-preview:before {
          color: #1890ff;
          font-size: 16px;
        }
      }

      /deep/ .el-form-item__label {
        text-align: left;
      }

      .one-box {
        text-align: center;
        width: 150px;
        height: 120px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        border: 1px dashed #eeebeb;
        padding-top: 30px;
        margin-right: 10px;
        display: flex;
        align-items: center;
        justify-content: center;

        .icon-plus {
          font-size: 20px;
          display: block;
          margin-top: 13px;
        }

        .text {
          // margin-top: 6px;
          color: #afaeae;
        }

        .edit-image {
          position: absolute;
          background: #858383;
          width: 50%;
          height: 30px;
          line-height: 30px;
          margin: 0 auto;
          border-radius: 5px;
          cursor: pointer;
          bottom: 8px;
          right: 25%;
          // margin-left: -30px;
          color: #fff;
          font-size: 12px;
        }

        .semi-close {
          position: absolute;
          top: -10px;
          right: 5px;
          width: 10px;
          height: 10px;
          border-radius: 50%;
          cursor: pointer;
        }

        img {
           max-width: 100%;
           max-height: 100%;
        }
      }

      .one-box-two {
        padding: 0;
        position: relative;
      }

      .one {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 10px;
        color: #1890ff;
        background: #ecf5ff;
        margin: 5px 5px;
        border-radius: 5px;

        .name {
          font-weight: 400;
          overflow: hidden;
          text-overflow: ellipsis;
          width: 90%;
          white-space: nowrap;  // 默认不换行；
        }

        .icon-close:before {
          color: #1890ff;
          position: relative;
          cursor: pointer;
        }

        .icon-st-doc-edit:before {
          color: #1890ff;
        }
      }
    }
  }

  .right {
    background: #fff;
    margin-left: 10px;
    max-width: 420px;
    // min-width: 200px;
    flex: 1;

    /deep/ .el-tabs--top .el-tabs__item.is-top:last-child {
      padding-right: 16px;
    }

    /deep/ .el-tabs--top .el-tabs__item.is-top:nth-child(2) {
      padding-left: 16px;
    }

    .acc-list {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin: 20px 0;
    }

    .el-upload-list__item-thumbnail {
      width: 148px;
      height: 148px;
    }
  }
}

.import,.template_modal {
  .tips {
    padding: 6px 20px;
    background: #f4f4f5;
    font-size: 13px;
    border-radius: 4px;
    margin-bottom: 30px;
  }

  .item{
    display: flex;
    align-items:center;
    justify-content: space-between;
    margin-top: 20px;

    p{
      margin-bottom: 0;
    }
  }

  /deep/ .ant-upload.ant-upload-drag p.ant-upload-drag-icon {
    margin-bottom: 6px;
  }

  .icon-edit-word,
  .icon-edit-ppt,
  .icon-edit-pdf,
  .icon-edit-excel {
    font-size: 34px;
  }
}

.hello {
  margin-left: 300px;
}
.form-box{
  padding: 10px 62px;
}

.setup-bt {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  padding: 15px 20px;
  /* height: 40px; */
  border-top: solid 1px #e9e9e9;
  position: absolute;
  bottom: 0px;
  width: 100%;
  background: #fff;

  .doc-set {
    display: flex;
    align-items: center;

    /deep/ .el-button {
      border: none;
    }
  }

  .icon-edit-preview:before {
    color: #1890ff;
    font-size: 16px;
  }
}

.middle-box {
  background: #fff;
}

/deep/ .el-tabs {
  background: #fff;
  padding-bottom: 40px;
}

.setup-bt-btn {
  display: flex;
}

.setup-bt-btn {
  display: flex;
  justify-content: space-between;
  width: 70%;
  max-width: 1000px;
}

.setup-bt-two {
  max-width: 420px;
  margin-left: 10px;
  flex: 1;
}

.setup-bt-one {
  width: 118px;
}

.middle-box {
  background: #fff;
}

/deep/ .el-tabs {
  background: #fff;
  padding-bottom: 40px;
}

.setup-bt {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  padding: 15px 20px;
  /* height: 40px; */
  border-top: solid 1px #e9e9e9;
  position: absolute;
  bottom: 0px;
  width: 100%;
  background: #fff;

  .doc-set {
    /deep/ .el-button {
      border: none;
    }
  }

  .icon-edit-preview:before {
    color: #1890ff;
  }
}

.tabs-box {
  display: flex;
  border-bottom: 1px solid rgba(217, 217, 217, 1);
  padding: 27px 30px;
  padding-bottom: 17px;
}

.tabs-dir {
  height: 4px;
  background: #1890ff;
  width: 140%;
  position: absolute;
  bottom: -17px;
  left: -10px;
}

.menhu {
  position: relative;
  cursor: pointer;
  flex: 1;
  margin-right: 30px;
  text-align: center;
}

.menhu:last-child {
  margin-right: 12px;
}

.item-error {
  height: 20px;
  color: red;
}

/deep/ .el-select {
  width: 100%;
}

/deep/ .el-input__inner {
  width: 100%;
}

.item-box-one {
  display: flex;
}

.label-box {
  width: 120px;
}

.dantu-upload {
  /deep/ .el-upload--picture-card {
    margin-left: 19px;
    margin-bottom: 18px;
  }
}

.new-close {
  cursor: pointer;
}

/deep/ .el-dialog__title {
  color: #000;
  font-weight: 600;
  font-size: 20px;
}

/deep/ .el-dialog__close {
  color: #000;
  font-weight: 600;
  font-size: 20px;
}

.colum-title-box {
  height: 34px;
  line-height: 34px;
  border-radius: 4px;
  background-color: rgba(244, 244, 245, 1);
  padding-left: 12px;
  color: rgba(144, 147, 153, 1);
  margin-bottom: 24px;
}

.column-box {
  /deep/ .el-dialog__body {
    padding-bottom: 8px !important;
  }
}

.acc-list {
  /deep/ .icon-close:before {
    position: relative;
    cursor: pointer;
  }
}

/deep/ .icon-close:before {
  position: relative;
  cursor: pointer;
  width: 12px;
  height: 12px;
  z-index: 1;
}

/deep/ .icon-edit-submit:before {
  color: #1890ff;
}

.back {
  cursor: pointer;
}

.dantu-yan {
  margin-right: 10px;
  position: absolute;
  top: 94px;
}

.img-box {
  width: 150px;
  height: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.add-img {
  width: auto !important;
  height: auto !important;
  max-width: 100%;
  max-height: 100%;
}

/deep/ .anticon-down {
  font-size: 12px;
}

/deep/ .anticon-up {
  margin-left: 5px;
  font-size: 13px;
}

.lai-yuan {
  /deep/ .el-input__inner{
    padding: 0;
  }
  /deep/ .el-input__inner::placeholder {
    color: #909399 !important;
    font-style: italic !important;
  }
}

/deep/ .el-button--small {
  font-size: 14px !important;
}

/deep/ .w-e-text-placeholder {
  color: #909399 !important;
}
/deep/ .edui-default .edui-editor-toolbarbox {
  position: sticky;
  top: -10px;
  z-index: 9999
}

/deep/ .edui-default .edui-editor-iframeholder, .edui-default .edui-editor-iframeholder iframe {
  max-height: 100vh;
  min-height: 400px;
}
.title-box {
  padding:0 5px;
  display: flex;
  align-items: center;
  border-radius: 2px;
  background-color: rgba(103, 194, 58, 1);
  color: rgba(255, 255, 255, 1);
  font-size: 12px;
  text-align: center;
  font-family: Roboto;
  text-align: center;
  margin: 5px;
}
.radio-box{
   /deep/ .el-radio{
    margin-bottom: 10px;
   }
}
.link-box{
    .name{
      display: flex;
      height: 22px;
      align-items: center;
      width: 100%;
    }
    .link-txt{
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
}
.editor-box{
      min-height:400px;
      padding: 0 62px
  }
  @media screen and (max-width: 1300px) {
     .middle{
      width: 56% !important;
     }
      /deep/ .edui-editor{
        z-index: 0 !important;
      }
       .editor-box{
          min-height:400px;
          padding: 0 12px
      }
  }
@media screen and (max-width: 900px) {
  .top{
     padding-left: 0px;
  }
  .middle{
      width: auto !important;
     }
  .tabs-dir{
    height: 4px;
    background: #1890ff;
    position: absolute;
    bottom: -17px;
    width: 90%;
    left: 10px;
  }
  .setup-bt-btn {
      //display: block;
      width: auto;
    }
  .content{
     display:block;
     .middle{
      width: auto;
     }
  }
  .content .middle .t-title .info{
       display:block;
  }
  .left{
    display: flex;
    flex-wrap: wrap;
    &::after{
      content: '';
      flex: 1;
    }
  }
  
  /deep/ .edui-editor{
    z-index: 0 !important;
  }
  .btn-item{
    width: 114px !important;
  }
  .editor-box{
      min-height:400px;
      padding: 0 12px
  }
  .content .right{
    margin-left: 0px;
    margin-top: 20px;
    padding-bottom: 130px;
    max-width: 100%;
  }
  .setup{
    margin-top: 20px;
  }
  /deep/ .el-button--medium {
    padding: 10px 14px;
  }
  .cg-box{
    padding: 0px;
    margin-right: 20px;
  }
  .btn-box{
    margin-left: 20px;
  }
  .setup-bt-one{
    width: auto;
  }
  .setup-bt{
    bottom: 0px;
    position: fixed;
}
}
@media screen and (max-width: 720px) {
   .content{
     height: 100vh !important;
  }
  .tabs-dir{
    height: 4px;
    background: #1890ff;
    position: absolute;
    bottom: -17px;
    width: 120%;
    left: -5px;
  }
  .btn-box{
    margin-top: 12px;
    margin-left: 0px;
  }
   .setup-bt-btn {
      display: block;
    }
    .form-box{
      padding: 10px 10px 10px 0px;
    }
    /deep/ .el-form-item__label{
      text-align: center !important;
    }
    .t-title{
      padding: 20px 12px !important;
    }
    .lai-yuan{
      margin-left: 14px;
    }
}
.template_modal /deep/  .ant-modal-footer{
  display: none !important;
}

</style>